import type { MarketCode } from 'config/markets/types';
import type { ExtendedPrice } from '../../../../product-context';

const MINIMUM_PRICE_DIFFERENCE_PERCENTAGE = 0.18;
const ALLOWED_MARKETS = ['gb', 'fr'];

const sortByScore = (a: ExtendedPrice, b: ExtendedPrice) => {
  if (a.ourChoiceScore === b.ourChoiceScore) {
    return 0;
  }
  return a.ourChoiceScore > b.ourChoiceScore ? -1 : 1;
};

const isMuchCheaperWithOneScoreBelow = (
  offer: ExtendedPrice,
  ourChoice: ExtendedPrice
) => {
  const ourChoicePrice =
    ourChoice.price?.inclShipping || ourChoice.price?.exclShipping || Infinity;
  const price =
    offer.price?.inclShipping || offer.price?.exclShipping || Infinity;
  const percentage = price / ourChoicePrice;
  return (
    offer.ourChoiceScore === ourChoice?.ourChoiceScore - 1 &&
    percentage <= 1 - MINIMUM_PRICE_DIFFERENCE_PERCENTAGE
  );
};

export const getOurChoiceOffer = (
  offersSortedByPrice: ExtendedPrice[],
  market: MarketCode
): ExtendedPrice | undefined => {
  if (!ALLOWED_MARKETS.includes(market)) {
    return undefined;
  }

  const filteredOffers = offersSortedByPrice.filter(
    offer =>
      offer.store?.featured &&
      offer.stock?.status === 'in_stock' &&
      offer.ourChoiceScore > 0
  );

  if (filteredOffers.length === 0) {
    return undefined;
  }

  const sortedOnScore = filteredOffers.sort(sortByScore);
  const ourChoice = sortedOnScore[0];

  const cheapestOfferWithSecondBestRank = sortedOnScore.find(offer =>
    isMuchCheaperWithOneScoreBelow(offer, ourChoice)
  );

  return cheapestOfferWithSecondBestRank || ourChoice;
};
